const INITIAL_STATE = {
  i18ns: []
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SET_DEVELOP_I18N_GRID': {
      return { ...state, i18ns: [...action.payload] };
    }
    default:
      return state;
  }
};
